/// <amd-module name="Wit/UI/Card/WorkItemCardHeader" />
export * from "./Components/WorkItemCardHeader/WorkItemCardHeader";
export { IWorkItemCardHeaderProps } from "./Components/WorkItemCardHeader/WorkItemCardHeader.Props";
